import type { RichTextElement, RichTextProps } from '@/app/components/rich-text/rich-text.types';
import { toRichTextContent } from '@/app/components/rich-text/rich-text.utils';

const DISCLAIMER_SKIP_TYPES = new Set(['image', 'embed']);

const toDisclaimerElements = (content: RichTextProps['content']): RichTextElement[] => {
    if (typeof content === 'string') {
        return toRichTextContent(content);
    }

    if (Array.isArray(content)) {
        return content;
    }

    return [content];
};

export const getAppMarketingDisclaimerBlocks = (content?: RichTextProps['content']): RichTextElement[] => {
    if (!content) {
        return [];
    }

    return toDisclaimerElements(content).filter(
        (element) => Boolean(element.text?.trim()) && !DISCLAIMER_SKIP_TYPES.has(element.type ?? '')
    );
};

export const hasAppMarketingDisclaimerContent = (content: RichTextProps['content'] | undefined): boolean =>
    getAppMarketingDisclaimerBlocks(content).length > 0;
